<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="itemOptions">

        <!--Options général-->
        <b-form-checkbox switch :size="chkSize" v-model="_ValideAge"><span class="txRate">{{$t('i_ValideAgeLegal')}}</span></b-form-checkbox>
        <b-form-checkbox switch :size="chkSize" v-model="_QteObligatoire"><span class="txRate">{{$t('i_QuantiteObligatoire')}}</span></b-form-checkbox>
        <b-form-checkbox switch :size="chkSize" v-model="_CadrinRapport"><span class="txRate">{{$t('i_RaportCadrin')}}</span></b-form-checkbox>
        <b-form-checkbox switch :size="chkSize" v-model="_Poids"><span class="txRate">{{$t('i_VenteAuPoid')}}</span></b-form-checkbox>
        <b-form-checkbox switch :size="chkSize" v-model="_CodePoids"><span class="txRate">{{$t('i_PoidsDansLecode')}}</span></b-form-checkbox>
        <b-form-checkbox switch :size="chkSize" v-model="_PrtEtiAuto"><span class="txRate">{{$t('i_EtiquetteAutomatique')}}</span></b-form-checkbox>
        <b-form-checkbox switch :size="chkSize" v-model="_Billet"><span class="txRate">{{$t('i_Billet')}}</span></b-form-checkbox>
        <b-form-checkbox switch :size="chkSize" v-model="_QteTuile"><span class="txRate">{{$t('i_VoirQuantiteSurTuile')}}</span></b-form-checkbox>
        <b-form-checkbox switch :size="chkSize" v-model="_PrintCommande"><span class="txRate">{{$t('i_ImpSurBonCommande')}}</span></b-form-checkbox>
        <b-form-checkbox switch :size="chkSize" v-model="_Consignation"><span class="txRate">{{$t('i_Consignation')}}</span></b-form-checkbox>

        <br>

        <!--Quantité taxable-->
        <b-row align-v="center">
            <b-col cols="3">
                <s-currencyInput class="MargeTop5" decimal="0" v-model="_QteTaxable"></s-currencyInput>                                            
            </b-col>
            <b-col class="aLeft" cols="9">
                <span class="txtSign">{{$t('i_QuantiteTaxable')}}</span>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemOptions',
    components: {

},
    props: ['ValideAge', 'QteObligatoire', 'CadrinRapport', 'Poids', 'CodePoids', 'PrtEtiAuto',
            'Billet', 'QteTuile', 'PrintCommande', 'QteTaxable', 'chkSize', 'Consignation'],
    data() {
        return {
            collaps: false,
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme']),
        _ValideAge: {
            get: function() {return this.ValideAge},
            set: function(modifiedValue){this.$emit('update:ValideAge', modifiedValue)}
        },
        _QteObligatoire: {
            get: function() {return this.QteObligatoire},
            set: function(modifiedValue){this.$emit('update:QteObligatoire', modifiedValue)}
        },
        _CadrinRapport: {
            get: function() {return this.CadrinRapport},
            set: function(modifiedValue){this.$emit('update:CadrinRapport', modifiedValue)}
        },
        _Poids: {
            get: function() {return this.Poids},
            set: function(modifiedValue){this.$emit('update:Poids', modifiedValue)}
        },
        _CodePoids: {
            get: function() {return this.CodePoids},
            set: function(modifiedValue){this.$emit('update:CodePoids', modifiedValue)}
        },
        _PrtEtiAuto: {
            get: function() {return this.PrtEtiAuto},
            set: function(modifiedValue){this.$emit('update:PrtEtiAuto', modifiedValue)}
        },
        _Billet: {
            get: function() {return this.Billet},
            set: function(modifiedValue){this.$emit('update:Billet', modifiedValue)}
        },
        _QteTuile: {
            get: function() {return this.QteTuile},
            set: function(modifiedValue){this.$emit('update:QteTuile', modifiedValue)}
        },
        _PrintCommande: {
            get: function() {return this.PrintCommande},
            set: function(modifiedValue){this.$emit('update:PrintCommande', modifiedValue)}
        },
        _QteTaxable: {
            get: function() {return this.QteTaxable},
            set: function(modifiedValue){this.$emit('update:QteTaxable', modifiedValue)}
        },
        _Consignation: {
            get: function() {return this.Consignation},
            set: function(modifiedValue){this.$emit('update:Consignation', modifiedValue)}
        }
    }
}
</script>

<style lang="scss" scoped>

</style>